import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData.js";
import moment from "moment";

export default function useSharedMethod() {

    const {$router, $moment} = useTools();

    function logout() {
        window.localStorage.clear();
        $router.push({name: 'signin'})
    }

    function getBack() {
        $router.go(-1);
    }

    const {itemColor, selectedOne} = useSharedData();

    function rowColor(item) {
        if (item.id === selectedOne.value.id) {
            return itemColor.value;
        }
    }

    function itemClick(item) {
        selectedOne.value = item;
    }


    function formatedMonth(date) {
        return date ? $moment(date).format("MM-YYYY") : "";
    }

    function formatedDate(date) {
        return date ? $moment(date).format("DD-MM-YYYY") : "";
    }

    function formatedDateTime(date) {
        return date ? $moment(date).format("DD-MM-YYYY HH:mm") : "";
    }

    function formatedTime(time) {
        if (time) {
            let momentTime = moment(time, "HH:mm:ss");
            return momentTime.format("HH:mm");
        } else {
            return "..:..";
        }
    }

    function priceFormat(value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }

    function transformFilterValues(filter) {
        const transformedFilter = {...filter};
        Object.keys(transformedFilter).forEach(key => {
            if (Array.isArray(transformedFilter[key])) {
                transformedFilter[key] = transformedFilter[key].toString(); // Convert array to comma-separated string
            }
        });
        return transformedFilter;
    }

    function getDialogToolbar(addAction,
                              updateAction,
                              deleteAction,
                              viewAction,
                              validateAction,
                              renewAction,
                              archiveAction,
                              unarchiveAction,
                              activateAction) {
        if (addAction) {
            return {color: 'teal', title: 'common.add'};
        } else if (updateAction) {
            return {color: 'orange', title: 'common.edit'};
        } else if (deleteAction) {
            return {color: 'red', title: 'common.delete'};
        } else if (viewAction) {
            return {color: 'blue', title: 'common.view'};
        } else if (validateAction) {
            return {color: 'teal', title: 'common.validate'};
        } else if (renewAction) {
            return {color: 'cyan', title: 'common.renew'};
        } else if (archiveAction) {
            return {color: 'purple', title: 'common.archive'};
        } else if (unarchiveAction) {
            return {color: 'purple', title: 'common.unarchive'};
        } else if (activateAction) {
            return {color: 'blue', title: 'common.activate'};
        }
    }

    function truncateString(str, maxLength) {
        if (!str)
            return "";
        if (str.length <= maxLength) {
            return str;
        }
        return str.substring(0, maxLength) + '...';
    }

    function getRootPath(type) {
        switch (type) {
            case "pharmacy":
                return "pharmacies";
            case "wholesaler":
                return "wholesalers";
            default:
                return "physicians";
        }
    }

    return {
        getRootPath,
        truncateString,
        transformFilterValues,
        logout,
        rowColor,
        itemClick,
        getBack,
        getDialogToolbar,
        formatedMonth,
        formatedDate,
        formatedDateTime,
        formatedTime,
        priceFormat,
    }
}